export default __webpack_public_path__ + "static/social-daily-report-db4796b4dd74db1adac37d21a639587f.png";